import React, { PropsWithChildren } from 'react';

import { TopNavigation, SideNavigation, PrivacyBanner, PrivacyFooter } from '.';

function Dashboard({ children }: PropsWithChildren<{}>) {
    return (
        <React.Fragment>
            <TopNavigation />
            <div className="flex h-[calc(100vh-49px)] flex-col">
                <main className="flex min-h-0 flex-1">
                    <SideNavigation />

                    {/* Content */}
                    <div className="relative flex flex-1 flex-col overflow-y-auto bg-white px-4 py-3">
                        {children}
                    </div>
                </main>

                {/* Full width, below both the side navigation and the content */}
                <PrivacyFooter />
            </div>

            <PrivacyBanner />
        </React.Fragment>
    );
}

export default Dashboard;
